import React from 'react';
import assign from 'object-assign';

import MenuItem from 'material-ui/MenuItem';
import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import SelectField from '../Common/SelectField';
import { Card, CardText } from 'material-ui/Card';

import EmailTemplateActions from '../../actions/EmailTemplateActionCreator';
import EmailTemplateStore from '../../stores/EmailTemplateStore';
import EmailTemplateTypeStore from '../../stores/EmailTemplateTypeStore';

const url = '/dashboard/email/templates';

const EmailTemplateForm = React.createClass({

    getInitialState: function () {

        return {

            isEdit: (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/)),

            details: {
                id: '',
                name: '',
                subject: '',
                body: '',
                notificationSubject: '',
                notificationBody: '',
                type: '',
                typeName: '',
                description: ''
            },
            typeOptions: [],

        }
    },

    componentDidMount: function() {

        if (this.state.isEdit) {
            this.listener = EmailTemplateStore.addListener(this.onTemplateChange);
            EmailTemplateActions.getById(this.props.routeParams.id);
        } else {
            this.listener = EmailTemplateTypeStore.addListener(this.onTemplateTypeChange);
            EmailTemplateActions.getTypes();
        }

    },

    componentWillUnmount: function() {
        this.listener.remove();
    },

    render: function() {
        const { details } = this.state;
        let formTitle  = (this.state.isEdit ? 'Edit' : 'New');
        let redirectTo = (this.state.isEdit ? `/dashboard/email/template/${details.id}` : url);

        let templateTypeProps = {
            name: 'type',
            floatingLabelText: 'Type',
            required: true
        };

        if (this.state.isEdit) {
            templateTypeProps.value = details.type;
            templateTypeProps.children = [<MenuItem key={details.type} value={details.type} primaryText={details.typeName} />];
        } else {
            templateTypeProps.children = this.state.typeOptions;
        }

        return (
            <Form
                title={formTitle}
                onSave={this.onSave}
                redirectTo={redirectTo}
            >
                <Card className="cent-card">
                    <CardText>
                        <TextField
                            name="name"
                            value={details.name}
                            validations="minLength:2,maxLength:80"
                            validationError="Please use only letters, at least 2"
                            hintText="Name"
                            floatingLabelText="Name"
                            required
                        />
                        <SelectField {...templateTypeProps} />

                        <TextField
                            name="subject"
                            value={details.subject}
                            validations="minLength:2,maxLength:120"
                            validationError="Please use only letters, at least 2"
                            hintText="Subject"
                            floatingLabelText="Subject"
                            required
                        />
                        <TextField
                            name="body"
                            value={details.body}
                            multiLine={true}
                            hintText="Body"
                            floatingLabelText="Body"
                            rowsMax={4}
                            required
                        />
                        <TextField
                            name="notificationSubject"
                            value={details.notificationSubject}
                            validations="minLength:2,maxLength:120"
                            validationError="Please use only letters, at least 2"
                            hintText="Notification subject"
                            floatingLabelText="Notification subject"
                        />
                        <TextField
                            name="notificationBody"
                            value={details.notificationBody}
                            multiLine={true}
                            hintText="Notification body"
                            floatingLabelText="Notification body"
                            rowsMax={4}
                        />

                    </CardText>
                </Card>
            </Form>
      );
    },

    onSave: function (model) {
        if(this.state.isEdit){
            return EmailTemplateActions.update(this.props.routeParams.id, model);
        } else {
            return EmailTemplateActions.save(model);
        }
    },

    onTemplateChange: function() {
        const template = EmailTemplateStore.getById(this.props.routeParams.id);
        if (template !== undefined) {
            let state = assign(this.state, {details: template});
            this.setState(state);
        }
    },

    onTemplateTypeChange: function() {
        const types = EmailTemplateTypeStore.getAll();
        if (types !== undefined) {
            let typeOptions = types.filter(function(e) { return e !== undefined && !!e.multiple; })
                .map(function(type) {
                    return <MenuItem key={type.id} value={type.internalName} primaryText={type.name} />
                });
            let state = assign(this.state, {typeOptions: typeOptions});
            this.setState(state);
        }
    }
});

export default EmailTemplateForm;
